export const StatusProcessamentoEnum = [
    { value: "1", label: "Recebido" },
    { value: "2", label: "Processando" },
    { value: "3", label: "Finalizado" },
    { value: "4", label: "Erro" },
  ]
  